export default function (Component) {
Component.options.__docs = "<p><code>FdToggle</code> has an optional label. Use the <code>on</code>-prop to turn a toggle on (<code>:on=true</code>) or off (<code>:on=false</code>). Set <code>disabled</code>-flag to disable user interaction.</p>\n"
}